import React, { useState } from "react";
import "./DogodkiPodstrani.css";

const images = [
  { src: "/Slike/Dogodki/Koncert2025/slika1.webp", text: "Slika 1: Skupno zbrane donacije za dogodek", alt:"Skupno zbrane donacije za dogodek"},
  { src: "/Slike/Dogodki/Koncert2025/slika2.webp", text: "Slika 2: Hana in Julija Dermol", alt:"Hana in Julija Dermol"},
  { src: "/Slike/Dogodki/Koncert2025/slika3.webp", text: "Slika 3: Hana in Julija Dermol", alt:"Hana in Julija Dermol" },
  { src: "/Slike/Dogodki/Koncert2025/slika4.webp", text: "Slika 4: Policijski orkester", alt:"Policijski orkester" },
  { src: "/Slike/Dogodki/Koncert2025/slika5.webp", text: "Slika 5: Panorama dogodka", alt:"Panorama dogodka"},
  { src: "/Slike/Dogodki/Koncert2025/slika6.webp", text: "Slika 6: Gostje prireditve", alt:"Gostje prireditve" },
  { src: "/Slike/Dogodki/Koncert2025/slika7.webp", text: "Slika 7: EROSI", alt:"Erosi" },
  { src: "/Slike/Dogodki/Koncert2025/slika8.webp", text: "Slika 8: Igor Oražem", alt:"Igor Oražem" },
  { src: "/Slike/Dogodki/Koncert2025/slika9.webp", text: "Slika 9: Mateja Bobek", alt:"Mateja Bobek" },
  { src: "/Slike/Dogodki/Koncert2025/slika10.webp", text: "Slika 10: IL Divji", alt:"IL Divji" },
  { src: "/Slike/Dogodki/Koncert2025/slika11.webp", text: "Slika 11: Voditeljica prireditve", alt:"Voditeljica prireditve" },
  { src: "/Slike/Dogodki/Koncert2025/slika12.webp", text: "Slika 12: Dirigent policijskega orkestra", alt:"Dirigent policijskega orkestra" },
  { src: "/Slike/Dogodki/Koncert2025/slika13.webp", text: "Slika 13: Pevski zbor", alt:"Pevski zbor" },
  { src: "/Slike/Dogodki/Koncert2025/slika14.webp", text: "Slika 14: Županja občine Vransko, Nataša Juhart in Aleksander Reberšek", alt:"Županja občine Vransko, Nataša Juhart in Aleksander Reberšek" },
  { src: "/Slike/Dogodki/Koncert2025/slika15.webp", text: "Slika 15: Policijski orkester", alt:"Policijski orkester" },
  { src: "/Slike/Dogodki/Koncert2025/slika16.webp", text: "Slika 16: Biljana Ann Novak", alt:"Biljana Ann Novak" },
  { src: "/Slike/Dogodki/Koncert2025/slika17.webp", text: "Slika 17: Gostje prireditve", alt:"Gostje prireditve" },
  { src: "/Slike/Dogodki/Koncert2025/slika18.webp", text: "Slika 18: Gašper Rifelj in Saša Lešnjek", alt:"Gašper Rifelj in Saša Lešnjek" },
  { src: "/Slike/Dogodki/Koncert2025/slika19.webp", text: "Slika 19: Tilen Lotrič", alt:"Tilen Lotrič" },
    { src: "/Slike/Dogodki/Koncert2025/slika20.webp", text: "Slika 20: Govor županje Nataše Juhart", alt:"Govor županje Nataše Juhart" },
    { src: "/Slike/Dogodki/Koncert2025/slika21.webp", text: "Slika 21: Govor predsednika Rotary Club Žalec, Primoža Temnika", alt:"Govor predsednika Rotary Club Žalec, Primoža Temnika" },
     { src: "/Slike/Dogodki/Koncert2025/slika22.webp", text: "Slika 22: Nina Pušlar", alt:"Nina Pušlar" },
      { src: "/Slike/Dogodki/Koncert2025/slika23.webp", text: "Slika 23: Nina Pušlar s policijskim orkestrom", alt:"Nina Pušlar s policijskim orkestrom" },
];

const KoncertVransko2025 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedText, setSelectedText] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);

  const handleImageClick = (image, text, index) => {
    setSelectedImage(image);
    setSelectedText(text);
    setCurrentIndex(index);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
    setSelectedText(null);
    setCurrentIndex(null);
  };

  const handleNext = () => {
    const nextIndex = (currentIndex + 1) % images.length;
    setSelectedImage(images[nextIndex].src);
    setSelectedText(images[nextIndex].text);
    setCurrentIndex(nextIndex);
  };

  const handlePrev = () => {
    const prevIndex = (currentIndex - 1 + images.length) % images.length;
    setSelectedImage(images[prevIndex].src);
    setSelectedText(images[prevIndex].text);
    setCurrentIndex(prevIndex);
  };

  return (
    <div className="dogodkipodstranigallerycontainer">
      <h1 className="dogodkipodstranigallerytitle">Koncert Žarek Upanja 06.11.2025 Vransko </h1>
      <h3>( Galerija Slik )</h3>
      <div className="dogodkipodstranigallery">
      {images.map((image, index) => (
        <div className="dogodkipodstranigalleryitem" key={index}>
          <img
             src={image.src}
             alt={image.alt}
             className="dogodkipodstranigalleryimage"
             loading={index < 4 ? "eager" : "lazy"} 
             onClick={() => handleImageClick(image.src, image.text, index)}
           />
         <p className="dogodkipodstraniimagetext">{image.text}</p>
       </div>
      ))}
      </div>

      <br></br>
      <p style={{ color: "#17458f" }}>( Število Fotografij : {images.length} )</p>

      {selectedImage && (
        <div className="dogodkimodal" onClick={handleCloseModal}>
          <div className="dogodkimodalcontent" onClick={(e) => e.stopPropagation()}>
            <button className="dogodkiarrow-left" onClick={handlePrev}>
              &#8592;
            </button>
            <img
              src={selectedImage}
              alt="Full-size event"
              className="dogodkimodalimage"
            />
            <p className="dogodkimodaltext">{selectedText}</p>
            <button className="dogodkiclosebutton" onClick={handleCloseModal}>
              X
            </button>
            <button className="dogodkiarrow-right" onClick={handleNext}>
              &#8594;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default KoncertVransko2025;